import type { SVGProps } from "react";
import * as React from "react";

const SvgCornerRightUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.293 8.293a1 1 0 0 0 1.414 1.414zM15 4l.707-.707a1 1 0 0 0-1.414 0zm4.293 5.707a1 1 0 0 0 1.414-1.414zM4 19a1 1 0 1 0 0 2zm11-3h1zm-4.293-6.293 5-5-1.414-1.414-5 5zm3.586-5 5 5 1.414-1.414-5-5zM4 21h7v-2H4zm7 0a5 5 0 0 0 3.536-1.465l-1.415-1.414A3 3 0 0 1 11 19zm3.536-1.465A5 5 0 0 0 16 16h-2a3 3 0 0 1-.879 2.121zM16 16V4h-2v12z"
    />
  </svg>
);
export default SvgCornerRightUp;
